import _ from 'lodash';
import moment from 'moment';
import * as ActionTypes from '../actions/constants';

const orderedCustomizationTypes = ['INVITATION', 'SAVE_THE_DATE', 'RSVP', 'RSVP_ENVELOPE', 'INVITATION_ENVELOPE'];

const initialState = {
  groupedDrafts: {
    orderedNames: []
  },
  drafts: [],
  orders: [],
  busy: false
};

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DRAFTS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_DRAFTS: {
      const drafts = action.payload
        .map(p => ({
          projectUUID: p.project_uuid,
          projectName: p.project_name,
          customizations: p.customizations.sort((a, b) => orderedCustomizationTypes.indexOf(a.type) - orderedCustomizationTypes.indexOf(b.type)),
          primaryCustomization: _.find(p.customizations, customization => customization.type === 'INVITATION' || customization.type === 'SAVE_THE_DATE')
        }))
        .sort((a, b) => moment(b.primaryCustomization.updated_at).valueOf() - moment(a.primaryCustomization.updated_at).valueOf());
      const groupedDrafts = drafts.reduce((result, draft) => {
        if (_.has(result, draft.projectName)) {
          result[draft.projectName].push(draft);
        } else {
          result.orderedNames.push(draft.projectName);
          result[draft.projectName] = [draft]; // eslint-disable-line
        }
        return result;
      }, { orderedNames: [] });

      return { ...state, drafts, groupedDrafts, busy: false };
    }
    case ActionTypes.REQUEST_COMPLETED: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_COMPLETED: {
      const orders = action.payload
        .map(o => ({
          createdAt: o.created_at,
          orderStatus: o.order_status,
          splitOrderID: o.split_order_id,
          projects: o.projects.map(p => ({
            projectUUID: p.project_uuid,
            projectName: p.project_name,
            completedAt: p.completed_at,
            quantity: p.quantity,
            primaryCustomization: _.find(p.customizations, customization => customization.type === 'INVITATION' || customization.type === 'SAVE_THE_DATE'),
            orderUUID: p.split_order_id,
            customizations: p.customizations.map(c => ({
              customizationUUID: c.project_customization_uuid,
              type: c.type,
              name: c.name,
              quantity: c.quantity,
              renders: c.renders,
              displayOrder: c.display_order,
              imageUrls: c.sku_view.image_urls,
              skuId: c.sku_view.object_id,
              priceCents: c.sku_view.price_cents,
              color: c.sku_view.product_option_values.color,
              // colorLabel: c.sku_view.product_option_values['color-label'] || 'this is a color',
              colorLabel: c.sku_view.product_option_value_labels.color,
              paperType: c.sku_view.product_option_values['paper-type'],
              reversePrinting: c.sku_view.product_option_values['reverse-printing'],
              envelopeLiningColor: c.sku_view.product_option_value_labels['envelope-lining-color'],
              shape: c.sku_view.product_option_values.silhouette,
              size: c.sku_view.product_option_values.size
            }))
          }))
        }))
        .sort((a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf());

      return { ...state, orders, busy: false };
    }
    case ActionTypes.RECEIVE_CANCELED_ORDER: {
      const { order } = action.payload;
      const formattedOrder = {
        createdAt: order.created_at,
        orderStatus: order.order_status,
        splitOrderID: order.split_order_id,
        projects: order.projects.map(p => ({
          projectUUID: p.project_uuid,
          projectName: p.project_name,
          completedAt: p.completed_at,
          quantity: p.quantity,
          primaryCustomization: _.find(p.customizations, customization => customization.type === 'INVITATION' || customization.type === 'SAVE_THE_DATE'),
          orderUUID: p.split_order_id,
          customizations: p.customizations.map(c => ({
            customizationUUID: c.project_customization_uuid,
            type: c.type,
            name: c.name,
            quantity: c.quantity,
            renders: c.renders,
            displayOrder: c.display_order,
            imageUrls: c.sku_view.image_urls,
            skuId: c.sku_view.object_id,
            priceCents: c.sku_view.price_cents,
            color: c.sku_view.product_option_values.color,
            // colorLabel: c.sku_view.product_option_values['color-label'] || 'this is a color',
            colorLabel: c.sku_view.product_option_value_labels.color,
            paperType: c.sku_view.product_option_values['paper-type'],
            reversePrinting: c.sku_view.product_option_values['reverse-printing'],
            envelopeLiningColor: c.sku_view.product_option_values['envelope-lining-color'],
            shape: c.sku_view.product_option_values.silhouette,
            size: c.sku_view.product_option_values.size
          }))
        }))
      };
      const updatedOrders = state.orders.map((currentOrder) => {
        if (currentOrder.splitOrderID === formattedOrder.splitOrderID) {
          return formattedOrder;
        }
        return currentOrder;
      });
      return { ...state, orders: updatedOrders };
    }
    default:
      return state;
  }
};

export default checkoutReducer;
// {
//   displayOrder: customization.display_order,
//   customizationUUID: customization.project_customization_uuid,
//   name: customization.name,
//   quantity: customization.quantity,
//   priceCents: customization.sku_view.price_cents,
//   imageUrls: customization.sku_view.image_urls,
//   color: customization.sku_view.product_option_values.color,
//   paperType: customization.sku_view.product_option_values['paper-type'],
//   shape: customization.sku_view.product_option_values.silhouette,
//   size: customization.sku_view.product_option_values.size,
// }



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/checkout.js
 **/